import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { updatepackagecancellationmethods } from "../axios";
import { getPenalty, addDayAvail } from "./filedata";

const CancellationForm = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      package_cancellation: [{ day_before: "", penalty: "", amount: "" }],
    },
  });

  useEffect(() => {
    // Check if cancellation policy data exists in the props
    console.log(props?.cancellation);
    if (props?.cancellation?.cancellation_policy != 'no_cancellationPolicy' && props?.cancellation?.cancellation_policy?.length > 0) {
      const cancellationPolicies = props.cancellation.cancellation_policy;

      // Set form values based on cancellation policy data
      setValue(
        "package_cancellation",
        cancellationPolicies.map((policy) => ({
          day_before: policy?.day_before_arrival,
          penalty: policy?.cancellation_penalty_id,
          amount: policy?.cancellation_value,
        }))
      );
    }

    // Set the policies text
    setValue("policies", props?.policies);
  }, [props.packageID, props?.cancellation?.cancellation_policy, setValue]);

  // Handle adding a new row
  const handleAddRows = () => {
    const lastRow = getValues("package_cancellation").slice(-1)[0];
    trigger(`package_cancellation[${getValues("package_cancellation").length - 1}]`).then((isValid) => {
      if (isValid && lastRow.day_before !== "") {
        setValue("package_cancellation", [
          ...getValues("package_cancellation"),
          { day_before: "", penalty: "", amount: "" },
        ]);
      }
    });
  };

  // Handle removing a row
  const handleRemoveRows = (index) => {
    const updatedRows = getValues("package_cancellation").filter((_, i) => i !== index);
    setValue("package_cancellation", updatedRows);
  };

  // Submit the form data
  const onSubmit = (data) => {
    const { package_cancellation, policies } = data;
    const package_id = props.packageID;

    updatepackagecancellationmethods(package_id, policies, package_cancellation).then(
      () => {
        // Optionally reload or show success message
      },
      (error) => {
        // Handle any errors during submission
      }
    );
  };

  // Helper function to check if the amount field should be disabled
  const isAmountDisabled = (penalty) => {
    return penalty === "1" || penalty === "2"; // "No Penalty" or "Full Amount"
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="form-group col-lg-3">Days Before Arrival</div>
              <div className="form-group col-lg-3">Penalty</div>
              <div className="form-group col-lg-4">Amount</div>
              <div className="form-group col-lg-2">Delete</div>
            </div>

            {/* Render each row dynamically */}
            {getValues("package_cancellation").map((row, index) => (
              <div className="row" key={index}>
                <div className="form-group col-lg-3">
                  <select
                    className="form-control"
                    {...register(`package_cancellation[${index}].day_before`, {
                      required: "This field is required",
                    })}
                    value={row.day_before}
                    onChange={(e) => {
                      setValue(`package_cancellation[${index}].day_before`, e.target.value);
                      trigger(`package_cancellation[${index}].day_before`);
                    }}
                  >
                    <option value="">Select Days</option>
                    {addDayAvail.map((option) => (
                      <option key={option.id} value={option.value}>
                        {option.value}
                      </option>
                    ))}
                  </select>
                  {errors.package_cancellation?.[index]?.day_before && (
                    <div className="text-danger">
                      {errors.package_cancellation[index].day_before?.message}
                    </div>
                  )}
                </div>

                <div className="form-group col-lg-3">
                  <select
                    className="form-control"
                    {...register(`package_cancellation[${index}].penalty`, {
                      required: "This field is required",
                    })}
                    value={row.penalty}
                    onChange={(e) => {
                      const penaltyValue = e.target.value;
                      setValue(`package_cancellation[${index}].penalty`, penaltyValue);
                      trigger(`package_cancellation[${index}].penalty`);

                      // Reset amount when penalty is "No Penalty" or "Full Amount"
                      if (penaltyValue === "1" || penaltyValue === "2") {
                        setValue(`package_cancellation[${index}].amount`, "");
                      }
                    }}
                  >
                    <option value="">Select Penalty</option>
                    {getPenalty.map((option) => (
                      <option key={option.id} value={option.value}>
                        {option.value}
                      </option>
                    ))}
                  </select>
                  {errors.package_cancellation?.[index]?.penalty && (
                    <div className="text-danger">
                      {errors.package_cancellation[index].penalty?.message}
                    </div>
                  )}
                </div>

                <div className="form-group col-lg-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Amount"
                    {...register(`package_cancellation[${index}].amount`, {
                      required: isAmountDisabled(row.penalty) ? false : "Amount is required",
                    })}
                    value={row.amount}
                    onChange={(e) => {
                      setValue(`package_cancellation[${index}].amount`, e.target.value);
                      trigger(`package_cancellation[${index}].amount`);
                    }}
                    disabled={isAmountDisabled(row.penalty)}
                  />
                  {errors.package_cancellation?.[index]?.amount && (
                    <div className="text-danger">
                      {errors.package_cancellation[index].amount?.message}
                    </div>
                  )}
                </div>

                {/* Only allow removal if more than one row exists */}
                {getValues("package_cancellation").length > 1 && (
                  <div className="form-group col-lg-2">
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{
                        fontSize: "14px",
                        marginRight: "5px",
                        cursor: "pointer",
                        marginTop: "10px",
                        color: "#a8a8a8",
                      }}
                      onClick={() => handleRemoveRows(index)}
                    />
                  </div>
                )}
              </div>
            ))}

            <div className="row">
              <div className="form-group col-lg-12">
                <button type="button" className="btn btn-primary" onClick={handleAddRows}>
                  Add Rule
                </button>
              </div>
            </div>

            <div className="row">
              <div className="form-group col-lg-12">
                <textarea
                  className="form-control"
                  rows="6"
                  placeholder="Other policies..."
                  {...register("policies")}
                ></textarea>
              </div>
            </div>

            <div className="col-lg-12 mt-3">
              <button type="submit" className="btn btn-success">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CancellationForm;
